export const offlinePattern = `
    <pattern id="offlinePattern" viewBox="0,0,5,5" width="3%" height="3%">
        <rect width="5" height="5" fill="#EAEEF1" />
        <circle r="1" cx="2.5" cy="0" fill="#9194A3"/>
        <circle r="1" cx="0" cy="2.5" fill="#9194A3"/>
        <circle r="1" cx="5" cy="2.5" fill="#9194A3"/>
        <circle r="1" cx="2.5" cy="5" fill="#9194A3"/>
    </pattern>
`;

export const onlinePattern = `
    <pattern id="onlinePattern" viewBox="0,0,5,5" width="3%" height="3%">
        <rect width="5" height="5" fill="#62D4A9" />
    </pattern>
`;

export const impactedPattern = `
    <pattern id="impactedPattern" viewBox="0,0,8,8" width="8%" height="8%" patternTransform="rotate(-45 0 0)">
        <line x1="2" y1="0" x2="2" y2="8" style="stroke:#DE1E32; stroke-width:4" />
        <line x1="6" y1="0" x2="6" y2="8" style="stroke:#F46A6A; stroke-width:4" />
    </pattern>
`;

export const atRiskPattern = `
    <pattern id="atRiskPattern" viewBox="0,0,8,8" width="8%" height="8%" patternTransform="rotate(45 0 0)">
        <line x1="2" y1="0" x2="2" y2="4" style="stroke:#FFBA5A; stroke-width:4" />
        <line x1="6" y1="1" x2="6" y2="7" style="stroke:#FFDDAD; stroke-width:2" />
    </pattern>
`;